module.exports = __webpack_public_path__ + "static/sec1-49cbe70205285e9fab87f88433bc6fc2.png";